<template>
  <Link
    v-bind="{ ...$props, ...$attrs }"
    class="panel-primary-btn"
  >
    <slot />
  </Link>
</template>

<script>
export default {
  props: {
    size: {
      type: String,
      default: 'md',
      validator: val => ['sm', 'md'].includes(val),
    },
  },
}
</script>
